// 1. Add CSS to hide specific sections when the lock notification is present
const style = document.createElement('style');
style.innerHTML = `
    .lock__notificationTemplateWrapper ~ section#shopify-section-multicolumn {
        display: none !important;
    }
    .lock__notificationTemplateWrapper ~ section#shopify-section-newsletter {
        display: none !important;
    }
`;
document.head.appendChild(style);
function modifyLockedPage() {
    const lockWrapper = document.querySelector('.lock__notificationTemplateWrapper');
    const lockBody = document.querySelector('.lock__notificationBody >h3')

    // 2. Add Teaser Banner image PRIOR to .lock__notificationTemplateWrapper
    const teaserImg = document.createElement('img');
    teaserImg.src = 'https://cdn.shopify.com/s/files/1/2384/2637/files/Teaser_Banner_Page.jpg?v=1768302635';
    teaserImg.style.width = '100%';
    teaserImg.style.maxWidth = '600px';
    teaserImg.style.display = 'block';
    teaserImg.alt = 'Teaser Banner';
    lockBody.parentNode.insertBefore(teaserImg, lockBody);

    // 3. Create and add the NESTED Klaviyo structure BELOW .lock__notificationTemplateWrapper
    const customNewsletter = document.createElement('section');
    customNewsletter.id = 'shopify-section-newsletter-custom'; // Unique ID to avoid conflicts
    customNewsletter.className = 'shopify-section';
    
    customNewsletter.innerHTML = `
        <div class="newsletter center newsletter--narrow page-width" id="KlaviyoNewsletterForm--locked">
            <div class="klaviyo-form-VYSz2h" style="margin: auto;width: 50rem;max-width: 100%;"></div>
        </div>
    `;
    
    // Insert the entire structure after the lock notification
    lockWrapper.parentNode.insertBefore(customNewsletter, lockWrapper.nextSibling);

    // 4. Klaviyo Script Loading Logic
    var klaviyoSubscribeSrc = 'https://www.klaviyo.com/media/js/public/klaviyo_subscribe.js';
    var klaviyoFormId = 'KlaviyoNewsletterForm--locked';

    function initKlaviyoForms() {
        if (window.KlaviyoSubscribe) {
            window.KlaviyoSubscribe.attachToForms('#' + klaviyoFormId, {
                success_message: '{{ "newsletter.success_html" | t }}',
                extra_properties: {
                    $source: 'ShopifyNewsletterSection',
                }
            });
        }
    }

    function loadScript(src, callback) {
        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = callback;
        document.head.append(script);
    }

    loadScript(klaviyoSubscribeSrc, initKlaviyoForms);
}



//document.addEventListener("DOMContentLoaded", ()=>{
window.addEventListener("load", ()=>{
    console.log("TESTMODIFY")
    console.log(document.querySelector('.lock__notificationTemplateWrapper'))
    if(document.querySelector('.lock__notificationTemplateWrapper') != null){
        modifyLockedPage();
    }
});


//modifyLockedPage();
